import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IMaintenanceReview } from 'app/shared/model/maintenance-review.model';
import { getEntities as getMaintenanceReviews } from 'app/entities/maintenance-review/maintenance-review.reducer';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { getEntity, updateEntity, createEntity, reset } from './maintenance-control.reducer';
import { IMaintenanceControl } from 'app/shared/model/maintenance-control.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MaintenanceControlUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const maintenanceReviews = useAppSelector(state => state.maintenanceReview.entities);
  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const maintenanceControlEntity = useAppSelector(state => state.maintenanceControl.entity);
  const loading = useAppSelector(state => state.maintenanceControl.loading);
  const updating = useAppSelector(state => state.maintenanceControl.updating);
  const updateSuccess = useAppSelector(state => state.maintenanceControl.updateSuccess);

  const handleClose = () => {
    props.history.push('/maintenance-control' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getMaintenanceReviews({}));
    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...maintenanceControlEntity,
      ...values,
      maintenanceReview: maintenanceReviews.find(it => it.id.toString() === values.maintenanceReviewId.toString()),
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...maintenanceControlEntity,
          maintenanceReviewId: maintenanceControlEntity?.maintenanceReview?.id,
          truckImplementId: maintenanceControlEntity?.truckImplement?.id,
          companyId: maintenanceControlEntity?.company?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.maintenanceControl.home.createOrEditLabel" data-cy="MaintenanceControlCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.maintenanceControl.home.createOrEditLabel">Create or edit a MaintenanceControl</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="maintenance-control-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.maintenanceControl.maintenance')}
                id="maintenance-control-maintenance"
                name="maintenance"
                data-cy="maintenance"
                check
                type="checkbox"
              />
              <ValidatedField
                id="maintenance-control-maintenanceReview"
                name="maintenanceReviewId"
                data-cy="maintenanceReview"
                label={translate('fleetSenseApp.maintenanceControl.maintenanceReview')}
                type="select"
              >
                <option value="" key="0" />
                {maintenanceReviews
                  ? maintenanceReviews.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="maintenance-control-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.maintenanceControl.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="maintenance-control-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.maintenanceControl.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/maintenance-control" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MaintenanceControlUpdate;
